import React from 'react';
import BookingTimer from './BookingTimer';
import './CheckoutTimer.css';

const CheckoutTimer = ({ onTimeout, startTime }) => {
    if (!startTime) return null;

    return (
        <div className="checkout-timer-container">
            <BookingTimer onTimeout={onTimeout} startTime={startTime} />
        </div>
    );
};

export default CheckoutTimer; 